import { render } from "./emoji_reactions.vue?vue&type=template&id=824ac3a4"
import script from "./emoji_reactions.js?vue&type=script&lang=js"
export * from "./emoji_reactions.js?vue&type=script&lang=js"

import "./emoji_reactions.vue?vue&type=style&index=0&id=824ac3a4&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__